module.exports = __webpack_public_path__ + "static/st1-3-66d564c0f43e90573b1afc3e2c569603.jpg";